// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WZ3s","questions":"styles_questions__2385a","footer":"styles_footer__1iMs8"};